module.exports = __webpack_public_path__ + "static/media/icon_home_blue.f800340b.svg";